module.exports = __webpack_public_path__ + "img/L2.9a871e71.png";